import { render, staticRenderFns } from "./CargosPendentesSistema.vue?vue&type=template&id=5378dc7f"
import script from "./CargosPendentesSistema.vue?vue&type=script&lang=ts"
export * from "./CargosPendentesSistema.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports